import { Component } from "../../../components/base/Component";
import { ICfa } from "../../../models/ICfa";
import { ComponentFactory } from "../../../services/ComponentFactory";

export class ImageCtaCarousel extends Component {
	public readonly sliderEl: JQuery;
	public slider: JQuery | null = null;
	public sliderContainer: JQuery;
	constructor(_element: HTMLElement, _app: ICfa) {
		super(_element, _app);
		this.sliderEl = $(_element);
		this.sliderContainer = this.sliderEl.find("[data-element='slider']");
		this.initSlider();
	}

	initSlider(): void {
		const sliderOptions: JQuerySlickOptions = {
			accessibility: false,
			arrows: true,
			centerMode: false,
			cssEase: "linear",
			dots: false,
			draggable: false,
			infinite: false,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						slidesToScroll: 1,
						slidesToShow: 3
					}
				}
			],
			slidesToScroll: 1,
			slidesToShow: 1,
			speed: 500,
			useTransform: false,
			variableWidth: true,
			prevArrow: $(this.sliderEl).find("[data-prev-arrow]"),
  			nextArrow: $(this.sliderEl).find("[data-next-arrow]"),
		};

		this.sliderContainer = this.sliderContainer.slick(sliderOptions);

		$(this.sliderEl)
			.find("[data-next-arrow]")
			.on("click", () => {
				this.sliderContainer.slick("slickNext");
			});

		$(this.sliderEl)
			.find("[data-prev-arrow]")
			.on("click", () => {
				this.sliderContainer.slick("slickPrev");
			});
	}

	get isMobileView(): boolean {
		const tabletMinWidth = 767;

		return window.innerWidth < tabletMinWidth;
	}
}

ComponentFactory.registerComponent("imageCtaCarousel", ImageCtaCarousel);
